import { Component, Input, OnInit } from '@angular/core';
import { IBaseComponent } from '../../configurator/i-base-component';
import { CarpentryConfiguratorItem } from '../../configurator/applications/carpentry-configurator-item';
import { CarpentryService } from 'src/app/services/configurators-2d/applications/carpentry.service';
import { Accessory } from 'src/app/models/configurators-2d/applications/carpentry/accessory/accessory';
import { ShoppingCartProductAccessory } from 'src/app/models/shopping-cart/shopping-cart-product-accessory';
import { QuotationRecord } from 'src/app/models/configurators-2d/applications/carpentry/quotation-record';
import { getPriceHtFromTtc, getPriceTtcFromHtAndTva } from 'src/app/services/helpers/formula-helper';

@Component({
  selector: 'ng-carpentry-accessories',
  templateUrl: './accessories.component.html',
})
export class CarpentryAccessoriesComponent extends CarpentryConfiguratorItem implements OnInit, IBaseComponent {
  @Input() quotationRecordId: number;

  /** Sous-étape pour les sections à afficher ou non */
  subStep: number = 1;
  product: QuotationRecord;
  accessories: Accessory[];
  initialAccessories: ShoppingCartProductAccessory[];
  baseImgUrl: string;

  constructor(carpentryService: CarpentryService) {
    super(carpentryService);
  }

  ngOnInit(): void {
    this.product = this.configuration.quotationRecords.find(q => q.externalId == this.quotationRecordId);
    this.service.getAccessories(this.product.productCode).then(accessories => {
      this.accessories = accessories.sort((a, b) => a.displayOrder - b.displayOrder);
    });
    this.initialAccessories = this.product.accessories.slice();
    this.baseImgUrl = this.service.getBaseImgUrl();
  }

  /** Fonction déterminant si l'accessoire est sélectionné */
  isAccessorySelected(id: string): boolean {
    return this.product.accessories.find(a => a.accessoryId === id) != undefined;
  }

  /** Fonction de sélection d'un accessoire */
  selectAccessory(accessory: Accessory): void {
    if (this.product.accessories.find(a => a.accessoryId === accessory.id)) {
      this.product.accessories = this.product.accessories.filter(a => a.accessoryId !== accessory.id);
      this.changeAfterOrder(accessory.id, 1, true);
    } else {
      this.product.accessories.push(new ShoppingCartProductAccessory(accessory, 1, this.product.tva));

      this.changeAfterOrder(accessory.id, 1, false);

      this.product.accessories.sort((a, b) => a.accessory.label.localeCompare(b.accessory.label));
    }
  }

  /** Fonction pour récupérer la quantité d'un accessoire */
  getAccessoryQuantity(id: string): number {
    const accessory = this.product.accessories.find(a => a.accessoryId === id);
    return accessory ? accessory.quantity : 0;
  }

  /** Fonction pour mettre à jour la quantité */
  updateQuantity(event: any, id: string): void {
    this.product.accessories.find(a => a.accessoryId === id).quantity = Number(event.target.value);
    this.changeAfterOrder(id, Number(event.target.value), false);
  }

  /** Fonction pour cocher l'accessoire */
  checkAccessory(id: string) {
    const checkbox: HTMLInputElement = document.getElementById(`title-${id}`) as HTMLInputElement;
    checkbox.checked = !this.isAccessorySelected(id) ? true : checkbox.checked;
  }

  /** Fonction pour décocher l'accessoire */
  uncheckAccessory(id: string) {
    const checkbox: HTMLInputElement = document.getElementById(`title-${id}`) as HTMLInputElement;
    checkbox.checked = !this.isAccessorySelected(id) ? false : checkbox.checked;
  }

  /** Fonction pour mettre à jour la date de modification si changement */
  changeAfterOrder(accessoryId: string, quantity: number, deleted: boolean) {
    if (deleted) {
      if (this.initialAccessories.some(a => a.accessory.id === accessoryId)) {
        this.configuration.configurationHasChanged = true;
      }
    } else if (!this.initialAccessories.some(a => a.accessory.id === accessoryId && a.quantity === quantity)) {
      this.configuration.configurationHasChanged = true;
    }
  }

  getPriceHt(accessory: Accessory): number {
    return getPriceHtFromTtc(accessory.priceTtc, accessory.tva);
  }

  getPriceTtc(accessory: Accessory): number {
    if (this.initialAccessories.some(a => a.accessory.id === accessory.id)) {
      return getPriceTtcFromHtAndTva(
        this.getPriceHt(accessory),
        this.initialAccessories.find(a => a.accessory.id === accessory.id).tva
      );
    }

    return getPriceTtcFromHtAndTva(this.getPriceHt(accessory), this.product.tva);
  }

  toggleCollapse(step: number) {
    this.subStep = step;
  }

  isNextButtonActive(): boolean {
    return this.checkPageChangeCapability();
  }

  checkPageChangeCapability(): boolean {
    return true;
  }
}
